import {STOCK} from '../Utils/stock'

const products = {

    stock: STOCK,
    cart: {
        items:[],
        total:0
    },
    purchased:[],
};

export default products;